export enum GameType {
  Cryptic = "cryptic",
  Quick = "quick",
  WordSearch = "wordSearch",
}
